module.exports = __webpack_public_path__ + "img/Newbie_Sword_01_Classic.4db58179.png";